import {
  elementOpen,
  elementClose,
  elementVoid
} from 'incremental-dom';

import appleLogo from './apple.svg';
import androidLogo from './android.svg';
import lighthouseLogo from './lighthouse.svg';
import webpagetestLogo from './webpagetest.svg';
export const lighthouseIcon = () => { lighthouseLogo('tech-icon');};
export const webpagetestIcon = () => { webpagetestLogo('tech-icon');};
export const appleIcon = () => appleLogo('apple-icon tech-icon');
export const androidIcon = () => { androidLogo('tech-icon');};


export const jsIconFull = (elId = 'jsId') => {
  const path = "m423.2 492.19c12.69 20.72 29.2 35.95 58.4 35.95 24.53 0 40.2-12.26 40.2-29.2 0-20.3-16.1-27.49-43.1-39.3l-14.8-6.35c-42.72-18.2-71.1-41-71.1-89.2 0-44.4 33.83-78.2 86.7-78.2 37.64 0 64.7 13.1 84.2 47.4l-46.1 29.6c-10.15-18.2-21.1-25.37-38.1-25.37-17.34 0-28.33 11-28.33 25.37 0 17.76 11 24.95 36.4 35.95l14.8 6.34c50.3 21.57 78.7 43.56 78.7 93 0 53.3-41.87 82.5-98.1 82.5-54.98 0-90.5-26.2-107.88-60.54zm-209.13 5.13c9.3 16.5 17.76 30.45 38.1 30.45 19.45 0 31.72-7.61 31.72-37.2v-201.3h59.2v202.1c0 61.3-35.94 89.2-88.4 89.2-47.4 0-74.85-24.53-88.81-54.075z";

  const el = elementOpen('svg', elId, null,
      'class', 'js-icon tech-icon content-loaded',
      'viewBox', '0 0 630 630'
  );
  elementVoid('rect', `jsiconrect2`, [
      'style', `fill: yellow;`,
      'width', '630',
      'height', '630'
  ]);
  elementVoid('path', `jsiconpath`, ['style', `fill: #000;`, 'd', path]);
  elementClose('svg');
  return el;

};

export const reduxIcon = (fillColor = '#764ABC') => {

  const paths = [
      "M65.6 65.4c2.9-.3 5.1-2.8 5-5.8-.1-3-2.6-5.4-5.6-5.4h-.2c-3.1.1-5.5 2.7-5.4 5.8.1 1.5.7 2.8 1.6 3.7-3.4 6.7-8.6 11.6-16.4 15.7-5.3 2.8-10.8 3.8-16.3 3.1-4.5-.6-8-2.6-10.2-5.9-3.2-4.9-3.5-10.2-.8-15.5 1.9-3.8 4.9-6.6 6.8-8-.4-1.3-1-3.5-1.3-5.1-14.5 10.5-13 24.7-8.6 31.4 3.3 5 10 8.1 17.4 8.1 2 0 4-.2 6-.7 12.8-2.5 22.5-10.1 28-21.4z",
      "M83.2 53c-7.6-8.9-18.8-13.8-31.6-13.8H50c-.9-1.8-2.8-3-4.9-3h-.2c-3.1.1-5.5 2.7-5.4 5.8.1 3 2.6 5.4 5.6 5.4h.2c2.2-.1 4.1-1.5 4.9-3.4H52c7.6 0 14.8 2.2 21.3 6.5 5 3.3 8.6 7.6 10.6 12.8 1.7 4.2 1.6 8.3-.2 11.8-2.8 5.3-7.5 8.2-13.7 8.2-4 0-7.8-1.2-9.8-2.1-1.1 1-3.1 2.6-4.5 3.6 4.3 2 8.7 3.1 12.9 3.1 9.6 0 16.7-5.3 19.4-10.6 2.9-5.8 2.7-15.8-4.8-24.3z",
      "M32.4 67.1c.1 3 2.6 5.4 5.6 5.4h.2c3.1-.1 5.5-2.7 5.4-5.8-.1-3-2.6-5.4-5.6-5.4h-.2c-.2 0-.5 0-.7.1-4.1-6.8-5.8-14.2-5.2-22.2.4-6 2.4-11.2 5.9-15.5 2.9-3.7 8.5-5.5 12.3-5.6 10.6-.2 15.1 13 15.4 18.3 1.3.3 3.5 1 5 1.5-1.2-16.2-11.2-24.6-20.8-24.6-9 0-17.3 6.5-20.6 16.1-4.6 12.8-1.6 25.1 4 34.8-.5.7-.8 1.8-.7 2.9z"
  ];

  elementOpen('svg', null, null,
      'class', 'redux-icon tech-icon',
      'viewBox', '0 0 100 100'
  );
  paths.map((p, i) => {
      elementVoid('path', `reduxiconpath-${i}`, ['style', `fill: ${'#764ABC'};`, 'd', p]);
  });
  elementClose('svg');
};

export const reactIcon = (fillColor = '#61dafb') => {

  const path = "M494.3,224.5c0-32.5-40.7-63.3-103.1-82.4,14.4-63.6,8-114.2-20.2-130.4a43.84,43.84,0,0,0-22.4-5.6V28.4A23.16,23.16,0,0,1,360,31c13.6,7.8,19.5,37.5,14.9,75.7-1.1,9.4-2.9,19.3-5.1,29.4a484.62,484.62,0,0,0-63.5-10.9,487.8,487.8,0,0,0-41.6-50c32.6-30.3,63.2-46.9,84-46.9V6h0c-27.5,0-63.5,19.6-99.9,53.6C212.4,25.8,176.4,6.4,148.9,6.4V28.7c20.7,0,51.4,16.5,84,46.6a472.31,472.31,0,0,0-41.3,49.9,467,467,0,0,0-63.6,11c-2.3-10-4-19.7-5.2-29-4.7-38.2,1.1-67.9,14.6-75.8,3-1.8,6.9-2.6,11.5-2.6V6.5h0a44.59,44.59,0,0,0-22.6,5.6C98.2,28.3,91.9,78.8,106.4,142.2,44.2,161.4,3.7,192.1,3.7,224.5s40.7,63.3,103.1,82.4c-14.4,63.6-8,114.2,20.2,130.4,6.5,3.8,14.1,5.6,22.5,5.6,27.5,0,63.5-19.6,99.9-53.6,36.4,33.8,72.4,53.2,99.9,53.2a44.59,44.59,0,0,0,22.6-5.6c28.1-16.2,34.4-66.7,19.9-130.1C453.8,287.7,494.3,256.9,494.3,224.5ZM364.1,157.8c-3.7,12.9-8.3,26.2-13.5,39.5-4.1-8-8.4-16-13.1-24s-9.5-15.8-14.4-23.4C337.3,152,351,154.6,364.1,157.8ZM318.3,264.3c-7.8,13.5-15.8,26.3-24.1,38.2-14.9,1.3-30,2-45.2,2s-30.2-.7-45-1.9q-12.45-17.85-24.2-38Q168.4,245,159,224.8c6.2-13.4,13.2-26.8,20.7-39.9,7.8-13.5,15.8-26.3,24.1-38.2,14.9-1.3,30-2,45.2-2s30.2.7,45,1.9q12.45,17.85,24.2,38,11.4,19.65,20.8,39.8C332.7,237.8,325.8,251.2,318.3,264.3Zm32.3-13c5.4,13.4,10,26.8,13.8,39.8-13.1,3.2-26.9,5.9-41.2,8,4.9-7.7,9.8-15.6,14.4-23.7S346.5,259.3,350.6,251.3ZM249.2,358a412.27,412.27,0,0,1-27.8-32c9,.4,18.2.7,27.5.7s18.7-.2,27.8-.7A390.33,390.33,0,0,1,249.2,358Zm-74.4-58.9c-14.2-2.1-27.9-4.7-41-7.9,3.7-12.9,8.3-26.2,13.5-39.5,4.1,8,8.4,16,13.1,24S169.9,291.5,174.8,299.1ZM248.7,91a412.27,412.27,0,0,1,27.8,32c-9-.4-18.2-.7-27.5-.7s-18.7.2-27.8.7A390.33,390.33,0,0,1,248.7,91Zm-74,58.9c-4.9,7.7-9.8,15.6-14.4,23.7s-8.9,16-13,24c-5.4-13.4-10-26.8-13.8-39.8C146.6,154.7,160.4,152,174.7,149.9ZM84.2,275.1C48.8,260,25.9,240.2,25.9,224.5s22.9-35.6,58.3-50.6c8.6-3.7,18-7,27.7-10.1a480.28,480.28,0,0,0,22.5,60.9,473.51,473.51,0,0,0-22.2,60.6C102.3,282.2,92.9,278.8,84.2,275.1ZM138,418c-13.6-7.8-19.5-37.5-14.9-75.7,1.1-9.4,2.9-19.3,5.1-29.4a484.62,484.62,0,0,0,63.5,10.9,487.8,487.8,0,0,0,41.6,50c-32.6,30.3-63.2,46.9-84,46.9A23.87,23.87,0,0,1,138,418Zm237.2-76.2c4.7,38.2-1.1,67.9-14.6,75.8-3,1.8-6.9,2.6-11.5,2.6-20.7,0-51.4-16.5-84-46.6a472.31,472.31,0,0,0,41.3-49.9,467,467,0,0,0,63.6-11A279.94,279.94,0,0,1,375.2,341.8Zm38.5-66.7c-8.6,3.7-18,7-27.7,10.1a480.28,480.28,0,0,0-22.5-60.9,473.51,473.51,0,0,0,22.2-60.6c9.9,3.1,19.3,6.5,28.1,10.2,35.4,15.1,58.3,34.9,58.3,50.6S449.1,260.1,413.7,275.1Z";

  elementOpen('svg', null, null,
      'class', 'react-icon tech-icon',
      'viewBox', '0 0 497.9 447.3'
  );
  elementVoid('path', `reacticonpath`, ['style', `fill: #61dafb;`, 'd', path]);
  elementVoid('circle', `reacticoncircle`, [
      'style', `fill: #61dafb;`,
      'cx', '248.9',
      'cy', '224.5',
      'r', '45.7'
  ]);

  elementClose('svg');
};

const adobeGradient = (id) => {
  elementOpen('radialGradient', null, [
      'id', id,
      'cx', "-183.69",
      'cy', "328.972",
      'r', ".76",
      'gradientTransform', 'matrix(545.6736 0 0 528.3113 100439.305 -173525.125)',
      'gradientUnits', 'userSpaceOnUse'
  ]);
      elementVoid('stop', null, [
          'offset', '0',
          'stop-color', '#423325',
          'stop-opacity', '.98'
      ]);
      elementVoid('stop', null, [
          'offset', '1',
          'stop-color', '#1c0a00'
      ]);
  elementClose('radialGradient');
};

const adobeIcon = (name, path, fill) => {

  const boxFill = "M24.803 155.549h545.674v530.792H24.803V155.549z";

  const el = elementOpen('svg', name, null,
      'class', `${name}-icon tech-icon`,
      'viewBox', '0 130.746 595.279 580.398'
  );
  adobeGradient(`${name}-grad`);
  elementVoid('path', null, ['d', boxFill, 'style', `fill: url(#${name}-grad)`]);
  if (path !== null) {
      elementVoid('path', null, ['d', path, 'style', `fill: ${fill}`]);
  } else {
      elementVoid('path', null, ['d', "M24.803 155.549h545.674v530.792H24.803V155.549zM0 711.145h595.28V130.746H0v580.399", 'style', `fill: ${fill}`]);
  }

  elementClose('svg');

  return el;
};

export const adobePS = (elId = 'psId') => {
  const iconPath = "M24.803 155.549h545.674v530.792H24.803V155.549zM0 711.145h595.28V130.746H0v580.399zm401.318-342.287c-19.595 0-26.291 9.921-26.291 18.106 0 8.929 4.464 15.13 30.756 28.772 38.941 18.851 51.095 36.957 51.095 63.497 0 39.685-30.26 61.016-71.186 61.016-21.579 0-40.182-4.465-50.847-10.665-1.736-.744-1.984-1.984-1.984-3.969v-36.461c0-2.48 1.24-3.225 2.977-1.984 15.626 10.17 33.484 14.634 49.854 14.634 19.595 0 27.78-8.185 27.78-19.347 0-8.929-5.705-16.866-30.757-29.764-35.221-16.866-49.854-33.98-49.854-62.504 0-31.997 25.052-58.536 68.457-58.536 21.331 0 36.213 3.225 44.398 6.945 1.984 1.24 2.48 3.224 2.48 4.96v33.98c0 1.984-1.24 3.225-3.721 2.48-10.913-6.943-27.035-11.16-43.157-11.16zm-213.309 29.516c5.705.496 10.17.496 20.091.496 29.021 0 56.304-10.169 56.304-49.606 0-31.5-19.595-47.375-52.583-47.375-9.921 0-19.347.496-23.812.744v95.741zM143.86 266.668c0-1.736 3.473-2.977 5.456-2.977 15.875-.744 39.438-1.24 63.993-1.24 68.705 0 95.492 37.701 95.492 85.82 0 63-45.638 90.036-101.693 90.036-9.425 0-12.649-.496-19.347-.496v95.245c0 1.984-.744 2.976-2.976 2.976h-37.949c-1.984 0-2.977-.744-2.977-2.976V266.668z";
  const el = adobeIcon(elId, iconPath, '#31c5f0');
  return el;
};

export const adobeIllustratorIcon = (elId = 'ailluId') => {

  const iconPath = "M24.803 155.549h545.674v530.792H24.803V155.549zM0 711.145h595.28V130.746H0v580.399zm389.908-373.539c0-1.984.744-2.977 2.977-2.977h38.941c1.983 0 2.976.744 2.976 2.977v195.699c0 1.983-.496 2.976-2.976 2.976h-38.445c-2.48 0-3.225-1.24-3.225-3.224V337.606h-.248zm-2.728-56.304c0-15.874 11.161-25.299 25.3-25.299 15.13 0 25.299 10.169 25.299 25.299 0 16.37-10.665 25.299-25.795 25.299-14.387.001-24.804-8.929-24.804-25.299zM275.565 419.209c-6.944-27.532-23.314-87.556-29.516-116.576h-.496c-5.209 29.02-18.354 78.13-28.771 116.576h58.783zm-68.953 40.182l-19.595 74.41c-.496 1.983-1.24 2.479-3.72 2.479h-36.461c-2.48 0-2.977-.744-2.48-3.72l70.441-246.546c1.24-4.464 1.984-8.433 2.48-20.586 0-1.736.744-2.48 1.984-2.48h52.087c1.736 0 2.48.496 2.977 2.48l78.874 267.628c.496 1.983 0 3.224-1.984 3.224h-41.174c-1.984 0-3.225-.496-3.72-2.231l-20.339-74.658h-79.37z";
  const el = adobeIcon(elId, iconPath, '#ff7f18');

  return el;

};

